import request from '@/lib/axios'
import Pagination from '@/lib/pagination'
import { filterQueryStringParams } from '@/lib/route'

export default class ContributorService extends Pagination {
  constructor () {
    super()
    this.isLoading = false
    this.params = {
      query: null,
      designations: null,
      page: 1
    }
    this.contributors = []
    this.append = false
  }

  searchQueryStringFilter (params) {
    let result = filterQueryStringParams(params)

    if (result.nsfw === false) {
      delete result.nsfw
    }

    return result
  }

  allParams () {
    return this.searchQueryStringFilter(this.params)
  }

  async fetch () {
    this.isLoading = true
    let results = await request({
      route: 'contributors',
      params: this.allParams()
    })
    this.setData(results.data.response.contributors, this.append)
    this.setPagination(results.data.response.contributors)
    this.isLoading = false
  }

  async addContributors () {
    await request({
      route: 'contributors.add',
      method: 'post',
      params: {
        uuids: this.contributors
      }
    })
  }
  async fetchNextPage () {
    this.params.page++
    this.append = true
    await this.fetch()
  }

  setData (data, append) {
    if (append) {
      this.data = [
        ...this.data,
        ...data.data
      ]
    } else {
      this.data = data.data
    }
  }

  reset () {
    this.append = false
    this.params.page = 1
    this.data = []
  }
}
